import axios from 'axios';
import { PUBLISHING_SERVICE_URL } from '../../config';
import { handleNetworkError, handleNetworkWarning, withVersionHeaders } from '../utilities/axiosUtilities';
import { logger } from '../utilities/logger';
export function parseJwt(jwt) {
  try {
    return JSON.parse(atob(jwt.split('.')[1]));
  } catch (e) {
    logger.error(e.message);
  }
  return null;
}

/**
 * This function communicates with token exchange service to obtain a JWT
 */
export function getSession() {
  return axios.get(`${PUBLISHING_SERVICE_URL}/sessions`, withVersionHeaders()).then(response => response.data).catch(handleNetworkWarning);
}

/**
 * This function communicates with token exchange service to obtain a JWT
 */
export function createSession(token) {
  return axios.post(`${PUBLISHING_SERVICE_URL}/sessions`, {
    token
  }, withVersionHeaders()).then(response => response.data).catch(handleNetworkError);
}

/**
 * This function communicates with token exchange service to obtain a JWT
 */
export function deleteSession() {
  return axios.delete(`${PUBLISHING_SERVICE_URL}/sessions`, withVersionHeaders()).then(response => response.data).catch(handleNetworkError);
}